export default {
  // Navigation
  nav_home: 'Ana Sayfa',
  nav_dashboard: 'Kontrol Paneli',
  nav_orders: 'Siparişler',
  nav_wallet: 'Cüzdan',
  nav_analytics: 'Analizler',
  nav_referral: 'Referanslar',
  nav_account: 'Hesap',
  nav_notifications: 'Bildirimler',
  nav_logout: 'Çıkış Yap',
  nav_login: 'Giriş Yap',
  nav_signup: 'Üye Ol',
  nav_deposit_requests: 'Para Yatırma Talepleri',
  nav_withdraw_requests: 'Para Çekme Talepleri',
  nav_support_ticket: 'Destek Talebi',
  nav_system_logs: 'Sistem Kayıtları',
  nav_announcements: 'Duyurular',
  nav_activity_logs: 'Aktivite Kayıtları',
  nav_settings: 'Ayarlar',
  nav_section_main: 'Ana Menü',
  nav_user_active: 'Çevrimiçi',
  nav_more: 'Daha Fazla',
  nav_logout_confirm: 'Çıkış yapmak istediğinizden emin misiniz?',
  nav_language: 'Dil',

  // Dashboard
  dashboard_welcome: 'Tekrar hoş geldiniz',
  dashboard_total_earnings: 'Toplam Kazanç',
  dashboard_pending_orders: 'Bekleyen Siparişler',
  dashboard_completed_orders: 'Tamamlanan Siparişler',
  dashboard_commission_rate: 'Komisyon Oranı',
  dashboard_quick_actions: 'Hızlı İşlemler',
  dashboard_recent_orders: 'Son Siparişler',
  dashboard_recent_activity: 'Son Aktiviteler',
  dashboard_wallet_balance: 'Cüzdan Bakiyesi',
  dashboard_deposit: 'Para Yatır',
  dashboard_withdraw: 'Para Çek',
  dashboard_view_all: 'Hepsini Gör',
  greeting_morning: 'Günaydın',
  greeting_afternoon: 'Tünaydın',
  greeting_evening: 'İyi Akşamlar',
  dashboard_greeting_desc: 'Kazançlarınızı takip edin, siparişleri tamamlayın ve hesabınızı tek bir yerden yönetin. Başarı yolculuğunuz burada devam ediyor!',

  // Dashboard Stats
  stats_available_balance: 'Kullanılabilir Bakiye',
  stats_total_withdrawn: 'Toplam Çekilen',
  stats_total_deposit: 'Toplam Yatırılan',
  stats_pending_orders: 'Bekleyen Siparişler',
  stats_orders_suffix: ' sipariş',
  stats_task_earnings: 'Görev Kazançları',
  stats_lifetime_earning: 'Ömür Boyu Kazanç',

  // Orders
  orders_title: 'Siparişlerim',
  orders_all: 'Tüm Siparişler',
  orders_pending: 'Bekliyor',
  orders_completed: 'Tamamlandı',
  orders_cancelled: 'İptal Edildi',
  orders_order_id: 'Sipariş No',
  orders_platform: 'Platform',
  orders_amount: 'Tutar',
  orders_commission: 'Komisyon',
  orders_status: 'Durum',
  orders_date: 'Tarih',
  orders_no_orders: 'Sipariş bulunamadı',

  // Wallet
  wallet_title: 'Cüzdanım',
  wallet_available_balance: 'Kullanılabilir Bakiye',
  wallet_pending_balance: 'Bekleyen Bakiye',
  wallet_total_withdrawn: 'Toplam Çekilen',
  wallet_deposit_now: 'Şimdi Yatır',
  wallet_withdraw_now: 'Şimdi Çek',
  wallet_transaction_history: 'İşlem Geçmişi',
  wallet_deposit_history: 'Para Yatırma Geçmişi',
  wallet_withdrawal_history: 'Para Çekme Geçmişi',
  wallet_deposit_desc: "Mevcut ödeme yöntemlerini kullanarak cüzdanınıza para ekleyin.",
  wallet_no_deposits: "Para yatırma bulunamadı.",
  wallet_withdraw_history: "Para çekme geçmişi",
  wallet_withdraw_desc: "Cüzdanınızdan para çekin.",
  wallet_no_withdrawals: "Para çekme bulunamadı.",
  wallet_no_withdrawals_desc: "Henüz para çekme işlemi yapmadınız.",

  // Analytics
  analytics_title: 'Analizler',
  analytics_earnings_overview: 'Kazanç Özeti',
  analytics_platform_breakdown: 'Platform Dağılımı',
  analytics_performance_metrics: 'Performans Metrikleri',
  analytics_top_products: 'En İyi Ürünler',
  analytics_this_month: 'Bu Ay',
  analytics_last_month: 'Geçen Ay',
  analytics_total_revenue: 'Toplam Gelir',
  analytics_avg_order_value: 'Ortalama Sipariş Değeri',

  // Referral
  referral_title: 'Referans Programı',
  referral_your_code: 'Referans Kodunuz',
  referral_copy_code: 'Kodu Kopyala',
  referral_share_link: 'Linki Paylaş',
  referral_total_referrals: 'Toplam Referans',
  referral_active_referrals: 'Aktif Referanslar',
  referral_referral_earnings: 'Referans Kazançları',
  referral_invite_friends: 'Arkadaşlarını Davet Et',

  // Account
  account_title: 'Hesap Ayarları',
  account_profile: 'Profil',
  account_security: 'Güvenlik',
  account_notifications: 'Bildirimler',
  account_kyc: 'Kimlik Doğrulama',
  account_phone: 'Telefon Numarası',
  account_two_factor: 'İki Faktörlü Doğrulama',
  account_save_changes: 'Değişiklikleri Kaydet',
  account_cancel: 'İptal',

  // Auth & Common
  auth_email: 'E-posta',
  auth_password: 'Şifre',
  auth_confirm_password: 'Şifreyi Onayla',
  auth_forgot_password: 'Şifremi Unuttum?',
  auth_remember_me: 'Beni Hatırla',
  auth_login_button: 'Giriş Yap',
  auth_signup_button: 'Üye Ol',
  auth_already_have_account: 'Zaten hesabınız var mı?',
  auth_dont_have_account: "Hesabınız yok mu?",
  auth_reset_password: 'Şifreyi Sıfırla',
  auth_verify_email: 'E-postayı Doğrula',
  auth_live_platform: 'Canlı Platform',
  auth_security_verification: 'Güvenlik Doğrulaması',
  auth_captcha_refresh: 'Yenile',
  auth_captcha_placeholder: 'Sonuç',
  auth_captcha_error: 'Hatalı sonuç, lütfen tekrar deneyin',
  auth_branding_title: 'Tanıtımları Şuna Dönüştür:',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Gerçek Gelir',
  auth_branding_desc: 'Dünyanın en iyi e-ticaret markalarından günlük komisyon kazanan binlerce tanıtımcıya katılın.',
  auth_sign_in_to_account: '{{system_name}} hesabınıza giriş yapın',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'Şifrenizi girin',
  auth_signing_in: 'Giriş yapılıyor...',
  auth_free_to_join: 'Katılmak Ücretsizdir',
  auth_signup_branding_title: 'Kazanmaya Başlayın',
  auth_signup_branding_highlight: 'İlk Günden İtibaren',
  auth_signup_branding_desc: 'Deneyim gerekmez. 2 dakikada kaydolun ve en iyi e-ticaret markaları için görevleri tamamlamaya başlayın.',
  auth_how_it_works: 'Nasıl çalışır?',
  auth_signup_desc: '{{system_name}}\'e katılın ve bugün komisyon kazanmaya başlayın — ücretsizdir!',
  auth_step_1: 'Ücretsiz hesabınızı oluşturun',
  auth_step_2: 'Görevleri inceleyin ve kabul edin',
  auth_step_3: 'Tamamlayın ve komisyon kazanın',
  auth_signup_step_1_title: 'Hesap Oluştur',
  auth_signup_step_1_desc: 'Yolculuğunuza başlayın',
  auth_signup_step_2_title: 'Görevleri Tamamla',
  auth_signup_step_2_desc: 'Günlük komisyonlar kazan',
  auth_signup_step_3_title: 'Para Çek',
  auth_signup_step_3_desc: 'Hızlı ve güvenli ödemeler',
  auth_benefit_1_title: 'Güvenli ve Güvenilir',
  auth_benefit_1_desc: 'Kazançlarınız için banka düzeyinde güvenlik',
  auth_benefit_2_title: 'Anında Ödemeler',
  auth_benefit_2_desc: 'Kazançlarınızı 24 saat içinde çekin',
  auth_benefit_3_title: 'Küresel Topluluk',
  auth_benefit_3_desc: '12.000+ aktif tanıtımcıya katılın',
  auth_benefit_4_title: '7/24 Destek',
  auth_benefit_4_desc: 'İhtiyacınız olduğunda yardım alın',
  auth_strength_weak: 'Zayıf',
  auth_strength_fair: 'Orta',
  auth_strength_good: 'İyi',
  auth_strength_strong: 'Güçlü',
  auth_password_strength: 'Şifre gücü: {{strength}}',
  auth_social_proof: '{{count}}+\'den fazla kazanana katılın',
  auth_passwords_match: 'Şifreler eşleşiyor',
  auth_creating_account: 'Hesap oluşturuluyor...',
  auth_phone_number: 'Telefon Numarası',
  auth_phone_optional: '(Opsiyonel)',
  auth_phone_placeholder: 'Telefon numaranız',
  auth_full_name: 'Ad Soyad',
  auth_full_name_placeholder: 'Ahmet Yılmaz',
  auth_password_min_chars: 'En az 8 karakter',
  auth_confirm_password_placeholder: 'Şifrenizi tekrarlayın',
  auth_agree_to: 'Kabul ediyorum:',
  auth_terms_of_service: 'Hizmet Koşulları',
  auth_privacy_policy: 'Gizlilik Politikası',
  auth_and: 've',
  auth_create_free_account: 'Ücretsiz Hesap Oluştur',

  common_loading: 'Yükleniyor...',
  common_save: 'Kaydet',
  common_cancel: 'İptal',
  common_delete: 'Sil',
  common_edit: 'Düzenle',
  common_view: 'Görüntüle',
  common_search: 'Ara',
  common_filter: 'Filtrele',
  common_export: 'Dışa Aktar',
  common_import: 'İçe Aktar',
  common_submit: 'Gönder',
  common_close: 'Kapat',
  common_confirm: 'Onayla',
  common_success: 'Başarılı',
  common_error: 'Hata',
  common_warning: 'Uyarı',
  common_announcement: 'Duyuru',

  val_full_name_required: 'Ad Soyad gereklidir',
  val_email_required: 'E-posta gereklidir',
  val_password_required: 'Şifre gereklidir',
  val_password_min: 'Şifre en az 8 karakter olmalıdır',
  val_passwords_dont_match: 'Şifreler eşleşmiyor',
  val_agree_terms: 'Koşulları kabul etmelisiniz',
  val_conn_error: 'Bağlantı hatası. Lütfen tekrar deneyin.',

  // Homepage
  home_hero_title: 'Popüler E-Ticaret Platformlarından Komisyon Kazanın',
  home_hero_subtitle: 'Walmart, Alibaba ve AliExpress\'ten günlük komisyon kazanan binlerce kullanıcıya katılın',
  home_get_started: 'Hemen Başlayın',
  home_learn_more: 'Daha Fazla Bilgi',
  home_how_it_works: 'Nasıl Çalışır?',
  home_features: 'Özellikler',
  home_why_choose_us: 'Neden Biz?',
  home_features_title: 'Güçlü Özellikler',
  home_features_subtitle: 'İnternetten kazanmaya başlamak için ihtiyacınız olan her şey. Başarınız için tasarlandı.',
  home_commission_tiers: 'Komisyon Seviyeleri',
  home_testimonials: 'Kullanıcılarımız Ne Diyor?',
  home_faq: 'Sıkça Sorulan Sorular',
  home_cta_title: 'Kazanmaya Başlamaya Hazır mısınız?',
  home_cta_subtitle: 'Bugün topluluğumuza katılın ve komisyon kazanmaya başlayın',
  home_trusted_partner: 'Güvenilir İş Ortağı Platformları',
  home_secure_platform: 'Güvenli Platform',
  home_instant_payouts: 'Anında Ödemeler',
  home_active_users: 'Aktif Kullanıcılar',
  home_paid_out: 'Ödenen',
  home_total_paid_out: 'Toplam Ödenen',
  home_user_rating: 'Kullanıcı Puanı',
  home_countries: 'Ülkeler',
  home_commission_badge: 'Kazanç Potansiyeli',
  home_commission_title: 'Komisyon Oranları',
  home_commission_desc: 'Daha yüksek bakiye, daha iyi komisyon oranlarının kilidini açar. Her oturumda tam 25 sipariş atanır — maksimum kazanç için günde 4 oturuma kadar tamamlayın.',
  home_tier_popular: 'En Popüler',
  home_tier_commission_per_order: 'Sipariş Başına Komisyon',
  home_tier_earn_examples: 'Kazanç Örnekleri:',
  home_tier_order: 'sipariş',
  home_tier_batch_earn: '25 sipariş/grup kazancı:',
  home_tier_daily_potential: 'Günlük Potansiyel (4 grup × 25 sipariş)',
  home_tier_max_daily: 'Günde 100 siparişe kadar',
  home_tier_benefit_1: 'Grup başına 25 sipariş',
  home_tier_benefit_2: 'Günde maksimum 4 grup',
  home_tier_benefit_3: 'Anında komisyon yüklemesi',
  home_tier_above: 'Üzeri',
  home_tier_no_tiers: 'Komisyon seviyesi bulunamadı.',

  // Comparison Section
  home_compare_badge: 'Farkımız',
  home_compare_title: 'Neden Daha İyiyiz?',
  home_compare_subtitle: 'Platformumuzu geleneksel yarı zamanlı işlerle karşılaştırın ve binlerce kişinin neden bizi seçtiğini görün.',
  home_compare_feature: 'Özellik',
  home_compare_traditional: 'Geleneksel İşler',
  home_compare_our_platform: 'Bizim Platformumuz',
  home_compare_f1: 'Esneklik',
  home_compare_f1_trad: 'Sabit çalışma saatleri',
  home_compare_f1_our: 'İstediğiniz zaman, istediğiniz yerde çalışın',
  home_compare_f2: 'Ödemeler',
  home_compare_f2_trad: 'Aylık veya iki haftalık',
  home_compare_f2_our: 'Anında / Aynı gün',
  home_compare_f3: 'Gereksinimler',
  home_compare_f3_trad: 'Deneyim/Özgeçmiş/Mülakat',
  home_compare_f3_our: 'Yok - Sadece bir akıllı telefon',
  home_compare_f4: 'Büyüme',
  home_compare_f4_trad: 'Sabit yıllık artışlar',
  home_compare_f4_our: 'Sınırsız seviye bazlı büyüme',

  // Testimonials
  home_testi_badge: 'Başarı Hikayeleri',
  home_testi_title: 'Binlerce Kişinin Güveni',
  home_testi_subtitle: 'Gelirlerini dönüştüren tanıtımcı topluluğumuzdan hikayeleri dinleyin.',
  home_testi_no_stories: 'Henüz başarı hikayesi bulunmuyor.',
  home_testi_total_earned: 'Toplam Kazanç',
  home_testi_time_period: 'Zaman Dilimi',
  home_testi_verified: 'Doğrulanmış Kullanıcı',
  home_testi_avg_rating: 'Ortalama Puan',
  home_testi_satisfaction_rate: 'Memnuniyet Oranı',
  home_testi_support_available: 'Destek Mevcut',

  // FAQ
  home_faq_badge: 'Destek',
  home_faq_title: 'Sıkça Sorulan Sorular',
  home_faq_subtitle: 'Başlamak ve kazanmak hakkında bilmeniz gereken her şey.',
  home_faq_no_data: 'Soru bulunamadı.',

  // Trust Bar
  home_trust_badge: 'Küresel Güven',
  home_trust_title: 'Lider Markaların Güveni',
  home_trust_desc: 'Doğrulanmış tanıtım hizmetleri sağlamak için dünyanın en büyük e-ticaret platformlarıyla ortaklık yapıyoruz.',

  // Feature Section
  feature_1_title: 'Anında Ödemeler',
  feature_1_desc: 'Sipariş tamamlandıktan hemen sonra kazançlarınız hesabınıza yansısın. Herhangi bir gecikme olmadan dilediğiniz zaman çekin.',
  feature_1_detail_1: 'Gerçek zamanlı komisyon aktarımı',
  feature_1_detail_2: 'Birden fazla çekim seçeneği',
  feature_1_detail_3: 'Alt limit yok',
  feature_2_title: 'Güvenli Platform',
  feature_2_desc: 'Banka düzeyinde şifreleme verilerinizi ve kazançlarınızı korur. Dünya çapında binlerce kullanıcı tarafından güvenilir.',
  feature_2_detail_1: 'SSL şifreleme etkin',
  feature_2_detail_2: 'İki faktörlü doğrulama',
  feature_2_detail_3: 'Düzenli güvenlik denetimleri',
  feature_2_detail_4: 'Veri gizliliği garantisi',
  feature_3_title: 'Esnek Saatler',
  feature_3_desc: 'İstediğiniz zaman, istediğiniz yerde çalışın. Siparişleri sabit bir programa bağlı kalmadan kendi hızınızda tamamlayın.',
  feature_3_detail_1: 'Sabit çalışma saati yok',
  feature_3_detail_2: 'Her yerden çalışma imkanı',
  feature_3_detail_3: 'Kendi hızınızı seçin',
  feature_3_detail_4: 'Hafta sonu uygunluğu',
  feature_4_title: 'Kademeli Kazançlar',
  feature_4_desc: 'Daha fazla sipariş tamamladıkça daha yüksek komisyon oranlarının kilidini açın. Her seviye atlamada gelirinizi artırın.',
  feature_4_detail_1: 'Seviye bazlı komisyon oranları',
  feature_4_detail_2: 'Otomatik seviye yükseltmeleri',
  feature_4_detail_3: 'Performans ödülleri',
  feature_5_title: 'Küresel Platform',
  feature_5_desc: 'Dünyanın her yerinden uluslararası markalarla çalışın. Çoklu para birimi desteği dahildir.',
  feature_5_detail_1: 'Dünya çapında mevcut',
  feature_5_detail_2: 'Çoklu para birimi desteği',
  feature_5_detail_3: 'Yerel ödeme yöntemleri',
  feature_6_title: '7/24 Destek',
  feature_6_desc: 'Özel destek ekibimiz her zaman yardıma hazır. Canlı sohbet, e-posta veya telefon aracılığıyla yardım alın.',
  feature_6_detail_1: 'Canlı sohbet mevcut',
  feature_6_detail_2: '7/24 e-posta desteği',
  feature_6_detail_3: 'Telefon yardımı',
  feature_6_detail_4: 'Kapsamlı SSS',
  feature_7_title: 'Referans Programı',
  feature_7_desc: 'Arkadaşlarınızı davet ederek ek gelir elde edin. Referanslarınızın kazançlarından ömür boyu komisyon alın.',
  feature_7_detail_1: 'Ömür boyu referans kazancı',
  feature_7_detail_2: 'Sınırsız referans',
  feature_7_detail_3: 'Kolay paylaşım araçları',
  feature_7_detail_4: 'Bonus teşvikleri',
  feature_8_title: 'Çoklu Para Birimi',
  feature_8_desc: 'Başlıca para birimleri ve ödeme yöntemleri desteği. Sizin için en uygun olanı seçin.',
  feature_8_detail_1: 'USD, EUR, GBP desteği',
  feature_8_detail_2: 'Banka havalesi mevcut',
  feature_8_detail_3: 'E-cüzdan entegrasyonu',
  feature_8_detail_4: 'Kripto seçenekleri yakında',
  feature_9_title: 'Anında Bildirimler',
  feature_9_desc: 'Yeni siparişler, kazançlar ve hesap aktiviteleri için gerçek zamanlı uyarılarla güncel kalın.',
  feature_9_detail_1: 'Anlık bildirimler',
  feature_9_detail_2: 'E-posta uyarıları',
  feature_9_detail_3: 'SMS güncellemeleri',
  feature_9_detail_4: 'Uygulama içi mesajlar',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Basit Süreç',
  home_how_it_works_title: 'Nasıl Çalışır?',
  home_how_it_works_subtitle: '4 basit adımda kazanmaya başlayın. Deneyim gerekmez, sadece süreci takip edin ve kazancınızın büyümesini izleyin.',
  home_cta_ready_title: 'Yolculuğunuza Başlamaya Hazır mısınız?',
  home_cta_ready_desc: 'Zaten günlük kazanan binlerce kullanıcıya katılın. İlk komisyonunuz sadece dakikalar uzağınızda!',
  home_cta_avg_time: 'İlk kazanca kadar geçen ortalama süre:',
  home_cta_15_mins: '15 dakika',
  home_cta_new_users: 'Bugün yeni kullanıcılar:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Bu Ay Sınırlı Kontenjan',
  home_cta_main_title: 'Para Kazanmaya Başlayın',
  home_cta_today: 'Hemen Bugün!',
  home_cta_main_desc: 'Günlük komisyon kazanan binlerce kullanıcıya katılın. Deneyim gerekmez, esnek saatler, anında ödemeler. Finansal özgürlüğünüz burada başlıyor.',
  home_cta_spots_remaining: 'Kalan Kontenjan',
  home_cta_new_users_today: 'Bugün Yeni Katılanlar',
  home_cta_create_account: 'Ücretsiz Hesap Oluştur',
  home_cta_sign_in: 'Giriş Yap',
  home_cta_secure: '%100 Güvenli',
  home_cta_payouts: '24-48 Saat İçinde Ödeme',
  home_cta_rating: '4.9/5 Puan',
  home_cta_active_users: 'Aktif Kullanıcılar',
  home_cta_total_paid: 'Toplam Ödenen',
  home_cta_orders_done: 'Tamamlanan Görevler',
  home_cta_satisfaction: 'Memnuniyet',
  home_cta_guarantee_title: 'Para İade Garantisi',
  home_cta_guarantee_desc: 'Memnun kalmadınız mı? 7 gün içinde yatırdığınız miktarı geri alın',

  // Footer Branding & Extras
  footer_brand_desc: 'Dünyanın lider e-ticaret tanıtım platformu. Bugün tanıtımcı ağımıza katılın ve en iyi markalardan komisyon kazanmaya başlayın.',
  footer_ssl_secure: 'SSL Korumalı',
  footer_aes_256: 'AES-256 Şifreleme',
  footer_cookie_policy: 'Çerez Politikası',
  footer_disclaimer: 'Sorumluluk Reddi',
  footer_all_rights: 'Tüm hakları saklıdır.',

  // Announcements
  announcement_withdrawal_delay_title: 'Para Çekme İşlemlerinde Gecikme',
  announcement_withdrawal_delay_summary: 'Yoğunluk nedeniyle para çekme işlemlerinin tamamlanması 72 saati bulabilir. Lütfen planlamanızı buna göre yapın.',
  announcement_date_june_14: '14 Haziran 2025',

  // How It Works Steps
  step_1_title: 'Kayıt Ol',
  step_1_desc: 'Hesabınızı oluşturmak 2 dakikadan az sürer.',
  step_1_detail_1: 'Temel bilgilerinizi girin',
  step_1_detail_2: 'E-posta adresinizi doğrulayın',
  step_1_detail_3: 'Hesabınızı güvenceye alın',
  step_1_detail_4: 'Paneli anında kullanmaya başlayın',
  step_2_title: 'Görev Seç',
  step_2_desc: 'Mevcut tanıtım görevleri arasından seçim yapın.',
  step_2_detail_1: 'Platforma göre filtrele',
  step_2_detail_2: 'Komisyon oranlarını gör',
  step_2_detail_3: 'Birden fazla görevi kabul et',
  step_2_detail_4: 'Gerçek zamanlı görev güncellemeleri',
  step_3_title: 'Görevi Tamamla',
  step_3_desc: 'Görevleri talimatlara göre tamamlayın.',
  step_3_detail_1: 'Takip etmesi kolay talimatlar',
  step_3_detail_2: 'Hızlı görev gönderimi',
  step_3_detail_3: 'Otomatik doğrulama',
  step_3_detail_4: 'Mobil uyumlu arayüz',
  step_4_title: 'Kazan ve Çek',
  step_4_desc: 'Tamamlanan her görev için ödeme alın.',
  step_4_detail_1: 'Gerçek zamanlı kazanç takibi',
  step_4_detail_2: 'Düşük para çekme alt limiti',
  step_4_detail_3: 'Çoklu ödeme yöntemleri',
  step_4_detail_4: '7/24 para çekme desteği',

  // Redesigned Footer
  footer_stay_loop_title: 'Haberdar Kalın',
  footer_stay_loop_desc: 'En son güncellemeleri, ipuçlarını ve özel teklifleri doğrudan gelen kutunuza alın.',
  footer_subscribe: 'Abone Ol',
  footer_subscribe_placeholder: 'E-posta adresinizi girin',
  footer_trusted_secure: 'GÜVENİLİR VE GÜVENLİ:',
  footer_ssl_secured: 'SSL Güvenceli',
  footer_ssl_secured_desc: '256-bit SSL',
  footer_aes_encryption: 'AES-256 Şifreleme',
  footer_aes_encryption_desc: 'Banka düzeyinde',
  footer_kyc_compliant: 'KYC Uyumlu',
  footer_kyc_compliant_desc: 'Doğrulandı',
  footer_gdpr_compliant: 'GDPR Uyumlu',
  footer_gdpr_compliant_desc: 'Veri Korumalı',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Sertifikalı',
  footer_platform: 'PLATFORM',
  footer_support: 'DESTEK',
  footer_legal: 'YASAL',
  footer_help_center: 'Yardım Merkezi',
  footer_contact_us: 'Bize Ulaşın',
  footer_payments_label: 'Ödemeler:',


  home_live_activity_title: 'Canlı Platform Etkinliği',
  home_recent_activity_title: 'Son Etkinlikler',
  home_total_commissions_paid: 'Ödenen Toplam Komisyon',
  home_active_users_online: 'Çevrimiçi Aktif Kullanıcılar',
  home_tasks_completed_today: 'Bugün Tamamlanan Görevler',
  account_security_tips_title: 'Güvenlik Önerileri',
  account_security_tips_desc: 'Bu basit en iyi uygulamaları takip ederek hesap korumanızı geliştirin.',
  tip_password_title: 'Güçlü Şifre',
  tip_password_desc: 'Hesabınızın güvende kalmasını sağlamak için harf, sayı ve sembollerin bir kombinasyonunu kullanın.',
  tip_two_factor_title: 'Kimlik Doğrulama',
  tip_two_factor_desc: 'Önemli güvenlik bildirimlerini almak için iletişim bilgilerinizi güncel tutun.',
  tip_logout_title: 'Düzenli Olarak Çıkış Yapın',
  tip_logout_desc: 'Her zaman ortak veya paylaşılan bilgisayarları kullanırken hesabınızdan çıkış yapın.',
  tip_sharing_title: 'Erişimi Asla Paylaşmayın',
  tip_sharing_desc: 'Destek ekibimiz asla şifrenizi istemeyecektir. Kimlik bilgilerinizi asla kimseyle paylaşmayın.',
};